import { useEffect, useState } from 'react'

/** The current time, refreshed every `intervalMs`, for countdowns that must move while the page sits open. */
export function useNow(intervalMs = 60_000): Date {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), intervalMs)
    return () => clearInterval(t)
  }, [intervalMs])
  return now
}
